import { render, staticRenderFns } from "./TeamItem.vue?vue&type=template&id=5422ddf2&scoped=true&"
import script from "./TeamItem.vue?vue&type=script&lang=js&"
export * from "./TeamItem.vue?vue&type=script&lang=js&"
import style0 from "./TeamItem.vue?vue&type=style&index=0&id=5422ddf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422ddf2",
  null
  
)

export default component.exports